import React from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Edges from "../../Edges"
import styled from "@emotion/styled"
import Button from "../../button/Button"

interface IFeaturedBlogsProps {
  postGroup: Array<any>
  headline: string
  button: any
}

export const FeaturedBlogs = ({
  postGroup = [],
  headline = "",
  button = "",
}: IFeaturedBlogsProps) => {
  return (
    <div className="mb-[40px]">
      <Edges size="2xl">
        {headline && (
          <h2 className="mx-auto max-w-lg pt-[60px]  text-center text-darkBlue">
            {headline}
          </h2>
        )}

        {postGroup && postGroup?.length > 0 && (
          <div className="mt-[40px] flex flex-row flex-wrap justify-center lg:flex-nowrap">
            {postGroup.map((post, index) => {
              const gatsbyImage =
                post?.featuredPosts?.featuredImage &&
                getImage(post.featuredPosts.featuredImage.node.gatsbyImage)

              return (
                <div
                  key={index}
                  className="my-[10px] flex flex-col items-center justify-center rounded mix-blend-normal lg:my-0"
                >
                  {gatsbyImage && (
                    <ImageContainer>
                      <GatsbyImage
                        image={gatsbyImage}
                        alt={
                          post?.featuredPosts?.featuredImage?.node?.altText ||
                          ""
                        }
                        className="mx-[10px] h-full shadow-[0_3px_13px_0px_rgba(0,0,0,0.16)] "
                      />
                      {post?.featuredPosts?.title &&
                        post?.featuredPosts?.title && (
                          <h4 className="absolute bottom-[45px] left-0 z-10 ml-[25px] max-w-[240px] text-white sm:ml-[45px]">
                            {post?.featuredPosts?.title}
                          </h4>
                        )}
                      {post?.featuredPosts?.uri && post?.featuredPosts.uri && (
                        <Link
                          className="SansProReg absolute bottom-[20px] left-0 z-10 ml-[25px] whitespace-nowrap text-linkButton text-yellow underline hover:no-underline sm:ml-[45px]"
                          to={post?.featuredPosts?.uri}
                        >
                          Read More
                        </Link>
                      )}
                    </ImageContainer>
                  )}
                </div>
              )
            })}
          </div>
        )}
        {button && button.url && (
          <div className="flex w-full justify-center pb-[60px]">
            <Button
              className="mt-[40px] ml-[12px] block sm:mt-[60px]  sm:hidden"
              variant="secondary"
              to={button.url}
              size="medium"
            >
              {button.title}
            </Button>
            <Button
              className="mt-[40px] ml-[12px] hidden sm:mt-[60px]   sm:block"
              variant="secondary"
              to={button.url}
              size="large"
            >
              {button.title}
            </Button>
          </div>
        )}
      </Edges>
    </div>
  )
}

export default FeaturedBlogs

export const fragment = graphql`
  fragment FeaturedBlogs on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_FeaturedBlogs {
      fieldGroupName
      headline
      button {
        target
        title
        url
      }
      postGroup {
        featuredPosts {
          ... on WpPost {
            id
            title
            uri
            featuredImage {
              node {
                altText
                gatsbyImage(
                  quality: 90
                  width: 395
                  height: 241
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
          ... on WpCaseStudy {
            id
            title
            uri
            featuredImage {
              node {
                altText
                gatsbyImage(
                  quality: 90
                  width: 395
                  height: 241
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }
    }
  }
`
const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  z-index: 1;

  .gatsby-image-wrapper {
    border-radius: 4px;
    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 2;
      left: 0;
      bottom: 0;
      background: linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0) 84.65%);
      border-radius: 4px;
    }
  }
`
